module.exports = __webpack_public_path__ + "img/award.21546f29.svg";